<template>
  <div class="container-fluid">
    
           <div class="main-image">
        <img
          src="https://www.doodhvale.com/img/desktop-banner3.png"
          class="big-banner"
          alt="Banner"
        />
        <img
          src="https://www.doodhvale.com/img/home-banner-3.png"
          class="small-banner"
          alt="Banner"
        />
      </div>
      <form
        action="#"
        target="_blank"
        style="height: 70px;"
      >
        <p style="text-align: center;">
          <br />
          <router-link :to="{ path: '/a/reg' }" class="sub-btn"
            >SUBSCRIBE MILK</router-link
          >
        </p>
      </form>

      <!-- App Download Links  -->
        <div
          class="container" align="center"
          style="padding: 20px 10px;"
        >
          <p
            style="font-size: 20px; font-weight: 600; text-align:center;"
          >
            Download the Doodhvale app on your phone
          </p>
          <div class="download-link">
            <a
              href="https://apps.apple.com/in/app/doodhvale/id1435706071"
              target="_main"
              ><img
                alt="appstore"
                src="https://www.doodhvale.com/img/appstore.png"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.technologies.subtlelabs.doodhvale"
              target="_main"
              ><img
                alt="googleplay"
                src="https://www.doodhvale.com/img/google-play.png"
              />
            </a>
          </div>
        
      <!-- !!App Download Links!!  -->

      <div class="hero-box">
        <div class="msg">
          <p
            style="font-size:20px;display: flex;font-weight: 600; justify-content: center;margin-bottom:0;"
          >
            Delivering Farm Happiness to your home with Love!
          </p>
        </div>
        <!-- About doodhvale -->
          <div class="hero-msg" style="text-align:center;">
            <p style="margin:10px 0px;">
              Doodhvale is a D2C dairy company that delivers high-quality milk
              products straight from the farm to the customer's doorstep. With
              Customer-first approach, Cutting-edge technology, and high focus
              on Quality, we are disrupting the broken and exploited Dairy
              industry!
            </p>
          </div>
          </div>
        <!-- grid view boxes -->

        <div class="grid-container">
          <div
            class="grid-item"
            style="border-bottom: 1px solid lightgrey;border-right: 1px solid lightgrey;"
          >
            <div class="msg-icon">
              <img src="static/img/icons/handshake.png" alt="" />
            </div>
            <p
              style="font-size: 20px;margin: 0px 0px 10px;font-weight: bold; width: 330px; text-align:center;"
            >
              Farm Fresh Pure and Happy Milk
            </p>
            <p style="font-size: 14px; width: 350px;">
              Doodhvale's milk comes from large Hi Tech dairy farms. The milk is
              natural, stress-free and delivered within 24-36 hours of milking.
            </p>
          </div>

          <div
            class="grid-item"
            style="border-bottom: 1px solid lightgrey;border-right: 1px solid lightgrey;"
          >
            <div class="msg-icon">
              <img src="static/img/icons/dropper.png" alt="" />
            </div>
            <p
              style="font-size: 20px;margin: 0px 0px 10px;font-weight: bold; width: 330px; text-align:center;"
            >
              Rigorous Daily Quality Testing
            </p>
            <p style="font-size: 16px; width: 350px;">
              We ensure high quality with scientific testing from cattle feed to
              final production. Customers gain confidence with our self-test
              kit, external certified lab report on 65+ parameters, and daily
              lab test report available on our app.
            </p>
          </div>

          <div class="grid-item" style="border-bottom: 1px solid lightgrey;">
            <div class="msg-icon">
              <img src="static/img/icons/freezing.png" alt="" />
            </div>
            <p
              style="font-size: 20px;margin: 0px 0px 10px;font-weight: bold; width: 330px;text-align:center;"
            >
              Grass to Glass - Enabled by Cold Chain
            </p>
            <p style="font-size: 16px; width: 350px;">
              Our pasteurization process and end-to-end cold-chain at 3°C
              maintains healthy shelf life for the milk and prevents any
              increase in bacteria counts.
            </p>
          </div>

          <div
            class="grid-item box4grid"
            style="border-right: 1px solid lightgrey;"
          >
            <div class="msg-icon">
              <img src="static/img/icons/house.png" alt="" />
            </div>
            <p
              style="font-size: 20px;margin: 0px 0px 10px;font-weight: bold; width: 330px;max-height:30px; text-align:center;"
            >
              Hassle-free, Free Home Delivery
            </p>
            <p style="font-size: 16px; width: 350px;">
              We believe in delivering fresh products to your doorstep without
              any hassle. Our delivery is free of cost, and we strive to ensure
              a hassle-free experience where our partners drop off the product
              in a bag hanging outside the customer's gate without any
              disturbance.
            </p>
          </div>

          <div class="grid-item" style="border-right: 1px solid lightgrey;">
            <div class="msg-icon">
              <img src="static/img/icons/smartphone.png" alt="" />
            </div>
            <p
              style="font-size: 20px;margin: 0px 0px 10px;font-weight: bold; width: 330px;text-align:center;"
            >
              User Friendly Mobile App
            </p>
            <p style="font-size: 16px; width: 350px;">
              Technology is at your fingertips. Our convenient mobile app allows
              customers to control their daily orders until 12 AM, with easy
              access to all our services including ordering, customer service,
              billing, payments, rewards, and offers.
            </p>
          </div>

          <div class="grid-item">
            <div class="msg-icon">
              <img src="static/img/icons/smile.png" alt="" />
            </div>
            <p
              style="font-size: 20px;margin: 0px 0px 10px;font-weight: bold; width: 330px; text-align:center;"
            >
              Loved by more than 50,000 Customers
            </p>
            <p style="font-size: 16px; width: 350px;">
              The customer is at the forefront of our venture. We are proud to
              be consistently appreciated and rated 4.5+ by thousands of happy
              families, from babies to the elderly.
            </p>
          </div>
        </div>

        <!-- !!!grid view boxes!!! -->
      </div>

      <!-- Api product list  -->

      <div class="apilist-innercontainer">
        <center>
          <h3 style="font-size:22px ;font-weight: 600;">Our Product</h3>
          <p style="font-size:16px; text-align:center;">
            We produce Fresh Milk and other Dairy Products
          </p>
        </center>
        <br />
        <div class="api-call" style="margin: auto;width:90%;">
          <ul>
            <li
              v-for="product in products"
              :key="product.product_id"
              v-if="product.cat_id == 2"
            >
              <div class="api-box">
                <div
                  class="product-image product_mobile_view_image productImageMobile"
                  style="text-align: center;"
                >
                  <img
                    :src="
                      product.product_image_s3_url
                        ? product.product_image_s3_url
                        : ''
                    "
                    alt="product.product_name"
                    class="prod-imagee"
                  />
                </div>
                <div class="api-info product_mobile_view_app_info" style="width:70vw;height:auto;">
                  <p
                    class="product_name mobileViewContent"
                    style="font-size:18px; margin: 10px 0px ;font-weight: 700;"
                  >
                    {{ product.product_name }}<br />
                  </p>
                  <p
                    class="product_description mobileViewContent"
                    style="font-size:14px;font-weight: 600;"
                  >
                    {{ product.product_description }}<br />
                  </p>
                  <p
                    class="prod_description"
                    style="font-size:16px;height:auto;text-align: justify;"
                  >
                    {{ product.prod_description }}
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- !!!!Api product list!!!!  -->
      <br />

      <!-- inner container -->
      <div class="innercontainer" width="auto">
        <div class="cont-img">
          <img
            src="https://www.doodhvale.com/img/Grocery3.jpg"
            alt="Unadlterarted Pure and Grocery"
          />
        </div>
        <div class="cont-heading">
          <center>
            <h3
              style="font-weight:bold;font-size: 22px;padding: 20px 0px 10px;margin: 0;"
            >
              Unadulterated Staples and Groceries - Need of the hour
            </h3>
          </center>
        </div>
        <div class="cont-info">
          <p style="margin: 15px 0px 16px;">
            At Doodhvale, we understand that good health is a top priority for
            everyone. That's why we source only the purest and most natural
            staples and spices directly from farmers, eliminating any
            possibility of unnatural mixing or adulteration. We cut out the
            middleman to offer the best possible prices for our customers. Our
            rigorous selection process ensures that all items are thoroughly
            cleaned and packed using the best materials before being delivered
            straight to your doorstep. With our convenient online shopping and
            delivery, you can save time, money, and effort while prioritizing
            your health. Download the Doodhvale app today and experience
            hassle-free shopping for all your kitchen essentials.
          </p>
        </div>
      </div>
      <br />
      <div class="innercontainer" width="auto">
        <div class="cont-img">
          <img
            src="https://www.doodhvale.com/img/fresh-fruits-vegetables-doodhvale.jpg"
            alt="Fresh and Hygienic Fruits and Vegetables"
          />
        </div>
        <div class="cont-heading">
          <center>
            <h3
              style="font-weight:bold;font-size: 22px;padding: 20px 0px 10px;margin: 0;"
            >
              Fresh and Hygienic Fruits and Vegetables
            </h3>
          </center>
        </div>
        <div class="cont-info">
          <p style="margin: 15px 0px 16px;">
            Fresh and chemical-free fruits and vegetables are critically
            important in your daily diet. That's why we offer a wide range of
            fresh and hygienic vegetables like potatoes, tomatoes, carrots,
            onions, and more, directly sourced from farmers and delivered to
            your doorstep. Our quality packaging ensures that the produce
            reaches you in the best condition possible. And with our competitive
            pricing, you can trust us to provide the best value for your money.
            Shop for your daily needs hassle-free on our online platform and
            enjoy the convenience of doorstep delivery.
          </p>
        </div>
      </div>
      <!-- !!!inner container!!! -->

      <form
        action="#"
        target="_blank"
        style="height: 70px;"
      >
        <p style="text-align: center;">
          <br />
          <router-link :to="{ path: '/a/reg' }" class="sub-btn"
            >SUBSCRIBE MILK</router-link
          >
        </p>
      </form>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      apiUrl: 'https://doodhvale.in/dv/',
      imgPreUrl: 'https://doodhvale.in',
      products: [],
      Productlist: []
    }
  },

  created () {
    const params = new URLSearchParams()
    params.append('user_id', 0)
    params.append('cat_id', 2)
    axios
        .post(
          this.apiUrl +
            'doodhvale/api/web/v3/products/products-with-pre-post-price',
          params
        ).then(response => {
          this.products = response.data.product_list
      // console.log("api loading");
      //  console.log("api called",this.products)
      // console.log("this.contents hi ")
        })
  }
}
</script>

<style scoped>
.form-sub {
  position: fixed;
  z-index: 1;
  top: 80px;
}
.sub-btn {
  background-color: #74c7fc;
  border-radius: 4px;
  color: #333;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  /* z-index: 1; */
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
}
.sub-btn:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  background-color: #ddd;
  color: black;
}
.container {
  user-select: none;
}
.main-image {
  margin: auto;
  margin-top: 40px;
}
.small-banner {
  display: none;
}
.container {
  margin: 0 auto;
  padding: 0 0;
  box-sizing: border-box;
}
.download-link {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}
.download-link img {
  height: 98px;
  width: 236px;
  padding: 15px 10px;
}
p {
  margin-bottom: 0;
  font-size: 16px;
}
/*  grid boxes  */
.grid-container {
  display: grid;
  grid-template-columns: 400px 400px 400px;
  justify-content: center;
}
.grid-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px 5px;
  margin: auto;
  width: 400px;
  height: 300px;
}
.msg-icon {
  max-width: 60px;
  height: auto;
}
.grid-item p {
  font-size: 16px;
}
/*  grid boxes  */
.items li {
  margin: 0;
  display: inline-block;
  border: 1px solid;
  width: 200px;
  text-align: center;
}
ul {
  list-style: none;
}
.items {
  margin-left: 15px;
}
.innercontainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: justify;
  width: 1100px;
  height: 540;
  padding: 0px 15px;
  margin: auto;
}
.cont-info {
  /* text-align:justify; */
  width: 1100px;
  height: 150px;
}
.cont-heading {
  width: 930px;
  height: auto;
}
.cont-img {
  width: 1100px;
  height: auto;
}

.prod-imagee {
  height: 200px;
  width: auto;
  margin: 0;
  padding: 0px 15px;
  /* margin: 4px; */
}

.api-box {
  display: flex;
  /* justify-content: space-between; */
}
.api-info {
  width: 100%;
}
.api-info p {
  margin: 0;
  width: 100%;
}

/* responsive section  */
@media (max-width: 1100px) {
  .big-banner {
    display: none;
  }
  .small-banner {
    display: flex;
    width: 100%;
    height: auto;
  }
  .form-sub {
    position: fixed;
    top: 80px;
  }
  .cont-info {
    width: 70%;
    height: auto;
    margin: auto;
  }
  .cont-img {
    width: 70%;
    height: auto;
    margin: auto;
  }
  .grid-container {
    display: grid;
    grid-template-columns: 400px 400px;
    justify-content: center;
  }
  .grid-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 10px 5px;
    margin: auto;
    width: 400px;
    height: 300px;
    border-right: 1px solid lightgrey;
    border-left: 1px solid lightgrey;
  }
  .box4grid {
    border-bottom: 1px solid lightgrey;
  }
}

@media (max-width: 860px) {
  .form-sub {
    position: fixed;
    top: 80px;
  }
  .innercontainer {
    width: 100vw;
  }
  .cont-info {
    width: 60%;
    height: auto;
    margin: auto;
  }
  .cont-img {
    width: 60%;
    height: auto;
    margin: auto;
  }
}
@media (max-width: 800px) {
  .form-sub {
    position: fixed;
    top: 80px;
  }
  .grid-container {
    display: grid;
    grid-template-columns: 400px;
    justify-content: center;
    font-size: 16px;
  }
}
@media (max-width: 550px) {
  .form-sub {
    display: none;
    position: none;
    /* top: 80px; */
  }
  .main-image {
    width: 100%;
    height: auto;
    margin: auto;
    /* margin-top: 40px; */
  }
  .download-link img {
    height: 72px;
    width: 154px;
    padding: 15px 10px;
  }
  .cont-heading {
    width: 60%;
    margin-right: 4px;
  }
  .cont-info {
    width: 100%;
    height: auto;
    margin: auto;
    margin-right: 4px;
  }
  .cont-img {
    width: 100%;
    height: auto;
    margin: auto;
    margin-right: 4px;
  }
  li {
    margin: 0;
    padding: 0;
    width: 100%;
  }
  .api-info {
    width: 100%;
  }
  .api-box {
    display: flex;
    flex-direction: column;
    text-align: center;
    /* justify-content: center; */
    /* align-items: center; */
    width: 100%;
  }
  .prod_description {
    width: 100%;
    margin-left: 20px;
    /* text-align: center; */
  }
  .product_description {
    width: 290px;
    height: auto;
  }
  .prod-imagee {
    max-width: 300px;
    min-height: 300px;
  }
  .container-fluid {
    width: 100%;
    padding-right: 1px;
    padding-left: 1px;
    margin-right: auto;
    margin-left: auto;
}
}

.container-fluid {
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
	}
.main-image {
     margin-top: 0; 
  }
  @media only screen and (max-width: 768px) {
  .product_mobile_view_image{
    width:50%;
  }
  .product_mobile_view_app_info{
    width:100% !important;
  }

  .productImageMobile{
	width:100% !important;
  }
  .mobileViewContent{
	text-align:center;
  }
}

  .productImageMobile{
	width:30vw;
  }


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/R.vue